import React, { useMemo } from "react";
import styles from "./UserWalletCompany.module.css";
import { LinearProgress } from "@mui/material";

function UserWalletCompany({ companyData }) {

  const progress = useMemo(() => {
    //try to parse progress text to number
    const parsedProgress = parseFloat(companyData?.progress_text);
    if(!isNaN(parsedProgress)){
      return Math.min(parsedProgress, 100);
    }
    //cucluate progress here current step by 5
    const percentage = Math.floor(
      companyData?.purchasingSteps || (0 / 5) * 100
    );
    return Math.min(percentage, 100);
  }, [companyData]);

  return (
    <div className={styles.container}>
      <div>
        My Stocks
        <div>
          <strong className="orangeFont">
            {/* {formatWithThousandsSeparators(numberOfStocks)} &nbsp; */}
            {companyData?.progress_text || "In Progress"}
          </strong>
          <div className="separatorEmptyMedium"></div>
          {/* <div className={styles.text}>
              <strong className="darkBlueFont" style={{
                whiteSpace:"nowrap",
                width:"150px",
                overflow:"hidden",
                textOverflow:"ellipsis"
              }}>{companyData?.progress_text}</strong>
          </div> */}
        </div>
      </div>
      <div className="separatorEmptyMedium"></div>
      <div>
        {/* Purchasing Steps */}
        {/* <div>
          <strong className="orangeFont">{renderPurchasingStepsText()}</strong>
        </div> */}
        {/* <div className="separatorEmptyMedium"></div> */}
        <div className="companyWalletProgress">
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <strong className="orangeFont">
              {/* {determineProgressValue()}% */}
            </strong>
            <LinearProgress
              variant="determinate"
              value={progress}
              style={{ width: "100%", height: "7px", borderRadius: "24px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserWalletCompany;
